import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { LocalService, ManagerService, ProfileService } from 'src/app/core';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';
import { MatOption, MatSelect, ProgressSpinnerMode, ThemePalette } from '@angular/material';
import { DataTableColumn } from 'src/app/shared/ui/data-table/data-table.component';
import * as XLSX from 'xlsx';
import { CONSTANTS } from 'src/app/config';
import { AngularEditorConfig } from '@kolkov/angular-editor';
@Component({
  selector: 'app-create-leaderboard-challenge',
  templateUrl: './create-leaderboard-challenge.component.html',
  styleUrls: ['./create-leaderboard-challenge.component.scss']
})
export class CreateLeaderboardChallengeComponent implements OnInit {

  constructor(private fb: FormBuilder, private managerService: ManagerService,
    private popupMessageService: PopupMessageService,
    private profileService: ProfileService) { }
  downloadExcelModalOpen = false;
  downloadExcelType = '';
  @ViewChild('select') select!: MatSelect;
  @Output() showLeaderboardChallenges = new EventEmitter()
  @Input() editedLeaderChallenge: any;
  @Input() copyLeaderChallenge:any;
  @ViewChild('selectRegion') selectRegion!: MatSelect;
  createNewChallengeForm!: FormGroup;
  fiscalOptionsList: any = [];
  fiscalYearList: any = [];
  fiscalQuarterList: any = [];
  regionsList = ["USA", "CANADA", "LATAM", "EMEAR", "APJ"];
  selectedLanguage!: string;
  roleList: any[] = [];
  countriesList: any = [];
  dropdownSettings: any = {}
  regionCountryMapping: any = []
  visibilityList: any = [{label: "Seller", value: "SELLER"}, {label: "Leader", value: "LEADER"}]
  challengeType: any = ['Leaderboard Challenge', 'Activity Challenge']
  userProfile: any = null;
  editedChallengeData: any;
  showSpinner: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 30;
  activityDropdownList: any = []
  budgetSourceList = ['CONTRA', 'OPEX'];
  selectedChallengeType:any;
  prereqActivityChallengeFlag:boolean=false;
  preReqFlag='';
  minPreRequisiteFlag:boolean=false;
  preReqData:any;
  readonlyFlag:boolean=false;
  uploadListModalOpen: boolean = false;
  uploadListDialogType: string = '';
  uploadListDialogData: any[] = [];
  uploadListPage: number = 1;
  readonly uploadListPageSize: number = 10;
  ngOnInit() {
    this.getFiscalOptions();
    this.getAllRoles();
    this.getCountriesByRegion();
   
    this.selectedLanguage = localStorage.getItem('selectedLanguage') as string;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'countryCode',
      textField: 'country',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      maxHeight: 200,
      noDataAvailablePlaceholderText: 'No selections made.'
    };
    this.userProfile = LocalService.get('userProfile');
    if(this.editedLeaderChallenge && this.editedLeaderChallenge.id){
      this.checkInactiveStatus();
    }
  }

  createLeaderboardFormForNew() {
    this.createNewChallengeForm = this.fb.group({
      activityName: ['', Validators.required],
      fiscalYear: ['', Validators.required],
      fiscalQuarter: ['', Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      cutOffDate: [null, Validators.required],
      assignRegion: [[], Validators.required],
      assignRole: [[], Validators.required],
      partnerCompanies: [[]],
      acronym:['',Validators.required],
      description: ['', Validators.required],
      challengeRewards: [null, [Validators.required]],
      selectallUsers:[false],
      participantGroup: this.fb.array([this.createParticipantArray()]),
      participantType: ['INDIVIDUAL', Validators.required],
      countryList: [[]],
      rewardType: ['POINTS', Validators.required],
      targetType: ['SAME_FOR_ALL_PARTICIPANTS', Validators.required],
      visibility: [[], Validators.required],
      preRequisites: [false],
      shouldClaim: [false],
      minPrerequisitesToBeMet: [''],
      budgetSource: ['', Validators.required],
      budgetCapByRegionGroup: this.fb.array([]),
      visibilityEndDate:[null]
    });
  }

  setCompanyFieldTouched() {
    this.createNewChallengeForm.get('countryList')!.markAsTouched()
  }

  createParticipantArray() {
    let participationFormGroup;
    participationFormGroup = this.fb.group({
      paticipantGroupName: ["", [Validators.required]],
      participantIds: [[], Validators.required],
      addTargetGroup: this.fb.array([this.createTargetGroupArray()]),
      rewardsRankingGroup: this.fb.array([this.createRankingGroupArray()]),
      minNoOfTargets: ["", [Validators.required]],
      deleted: [false]
    });
    // let rewardType = this.createNewChallengeForm ? this.createNewChallengeForm.controls.rewardType.value : 'POINTS'
    // if (rewardType === 'MANUAL') {
    //   participationFormGroup = this.fb.group({
    //     paticipantGroupName: ["", [Validators.required]],
    //     participantIds: [[], Validators.required],
    //     addTargetGroup: this.fb.array([this.createTargetGroupArray()]),
    //     rewardsRankingGroup: this.fb.array([]),
    //     minNoOfTargets: ["", [Validators.required]],
    //     deleted: [false]
    //   });
    // } else {
    //   participationFormGroup = this.fb.group({
    //     paticipantGroupName: ["", [Validators.required]],
    //     participantIds: [[], Validators.required],
    //     addTargetGroup: this.fb.array([this.createTargetGroupArray()]),
    //     rewardsRankingGroup: this.fb.array([this.createRankingGroupArray()]),
    //     minNoOfTargets: ["", [Validators.required]],
    //     deleted: [false]
    //   });
    // }
    return participationFormGroup
  }

  createTargetGroupArray() {
    let targetType = this.createNewChallengeForm ? this.createNewChallengeForm.controls.targetType.value : 'SAME_FOR_ALL_PARTICIPANTS'
    if (targetType === 'SAME_FOR_ALL_PARTICIPANTS') {
      return this.fb.group({
        id: [null],
        targetGroupName: ["", [Validators.required]],
        eligibleProductSkus: [[]],
        eligibleProductSkusNotApplicable: [false],
        eligibleProductFamilies: [[]],
        eligibleProductFamiliesNotApplicable: [false],
        setTargets: [null],
        minTargets: ["", [Validators.required]],
        isOptional: [false],
        deleted: [false]
      }, { validator: this.skuOrFamilyDataRequired});
    } else {
      return this.fb.group({
        id: [null],
        targetGroupName: ["", [Validators.required]],
        eligibleProductSkus: [[]],
        eligibleProductSkusNotApplicable: [false],
        eligibleProductFamilies: [[]],
        eligibleProductFamiliesNotApplicable: [false],
        setTargets: [[], [Validators.required]],
        minTargets: [null],
        isOptional: [false],
        deleted: [false]
      }, { validator: this.skuOrFamilyDataRequired});
    }
  }

  skuOrFamilyDataRequired(group : FormGroup) : {[s:string ]: boolean} | null {
    if (group) {
      if(group.controls['eligibleProductSkus'].value.length > 0 
      || group.controls['eligibleProductFamilies'].value.length > 0
      || group.controls['eligibleProductSkusNotApplicable'].value
      || group.controls['eligibleProductFamiliesNotApplicable'].value) {
        return null;
      }
    }
    return {'error': true};
  }

  createRankingGroupArray() {
    return this.fb.group({
      position: ["", Validators.required],
      points: ["", Validators.required]
    });
  }

  createPreRequisitesArray() {
    return this.fb.group({
      challengeType: ["", Validators.required],
      activityChallenge: ["", Validators.required],
      isOptional: [false, Validators.required]
    })
  }

  getParticipantList(form: any) {
    return form.controls.participantGroup.controls;
  };

  getParticipantTargetsList(form: any, index: any) {
    return form.controls.participantGroup.controls[index].controls.addTargetGroup.controls
  }

  getParticipantRankingsList(form: any, index: any) {
    return form.controls.participantGroup.controls[index].controls.rewardsRankingGroup.controls
  }

  getRequisitesList(form: any) {
    return form.controls.preRequisitesGroup && form.controls.preRequisitesGroup.controls;
  };

  addParticipationGroup() {
    const control = <FormArray>this.createNewChallengeForm.get('participantGroup');
    control.push(this.createParticipantArray());
  };

  addTargetGroup(index: any) {
    const control = <FormArray>(this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('addTargetGroup');
    control.push(this.createTargetGroupArray());
  }

  removeTargetBlock(i: any, j: any) {
    if (this.editedChallengeData.productsBookingLdbChPgList[i] &&
      this.editedChallengeData.productsBookingLdbChPgList[i].productsBookingLdbChTargetList[j] &&
      this.editedChallengeData.productsBookingLdbChPgList[i].productsBookingLdbChTargetList[j].id) {
      (this.createNewChallengeForm.controls.participantGroup as any)['controls'][i].get('addTargetGroup').controls[j].controls.deleted.setValue(true);
    } else {
      const control = <FormArray>(this.createNewChallengeForm.get('participantGroup') as any)['controls'][i].get('addTargetGroup');
      control.removeAt(j)
    }
  }

  addRankingsGroup(index: any) {
    const control = <FormArray>(this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('rewardsRankingGroup');
    control.push(this.createRankingGroupArray());
  }

  removeRankingGroup(i: any, k: any) {
    const control = <FormArray>(this.createNewChallengeForm.get('participantGroup') as any)['controls'][i].get('rewardsRankingGroup');
    control.removeAt(k);
  }

  addPreRequisitesGroup() {
    const control = <FormArray>this.createNewChallengeForm.get('preRequisitesGroup');
    control.push(this.createPreRequisitesArray());
  }

  removePreRequisitesGroup(index: any) {
    const control = <FormArray>this.createNewChallengeForm.get('preRequisitesGroup');
    control.removeAt(index)
    this.prereqActivityChallengeFlag=false;
  }

  setIdentifier() {
    let acronym = "AC-" + 'PRODUCT-BOOK';
 
    let challengeName = '';
    if (this.createNewChallengeForm.value.fiscalYear && this.createNewChallengeForm.value.fiscalQuarter.length > 0) {
      let periodStartData = this.fiscalOptionsList.filter((x: any) => x.fiscalYear == this.createNewChallengeForm.value.fiscalYear
        && x.fiscalQuarter == this.createNewChallengeForm.value.fiscalQuarter[0])[0]
      let periodEndData = this.fiscalOptionsList.filter((x: any) => x.fiscalYear == this.createNewChallengeForm.value.fiscalYear
         && x.fiscalQuarter == this.createNewChallengeForm.value.fiscalQuarter[this.createNewChallengeForm.value.fiscalQuarter.length - 1])[0]
      const sd = new Date(periodStartData.startDate);
      const ed = new Date(periodEndData.endDate);
      const startDate = new Date(sd.getUTCFullYear(), sd.getUTCMonth(), sd.getUTCDate());
      const endDate = new Date(ed.getUTCFullYear(), ed.getUTCMonth(), ed.getUTCDate());

      this.createNewChallengeForm.controls.startDate.setValue(startDate);
      this.createNewChallengeForm.controls.endDate.setValue(endDate);
    }

    if (this.createNewChallengeForm.value.activityName) {
      this.createNewChallengeForm.value.activityName.split(" ").filter((e: any)=>e.trim()).forEach((x: any) => {
        challengeName += x.charAt(0).toUpperCase();
      });
    }
    let yearVal: any;
    if (this.createNewChallengeForm.value.fiscalYear) {
      yearVal = this.createNewChallengeForm.value.fiscalYear;
    }
    let quarterVal: any;
    if (this.createNewChallengeForm.value.fiscalQuarter) {
      quarterVal = this.createNewChallengeForm.value.fiscalQuarter[this.createNewChallengeForm.value.fiscalQuarter.length - 1];
    }
    if (challengeName) {
      acronym = acronym + '-' + challengeName
    }
    if (quarterVal) {
      acronym = acronym + '-' + quarterVal
    }
    if (yearVal) {
      acronym = acronym + yearVal
    }
    this.createNewChallengeForm.controls.acronym.setValue(acronym);
  };

  getFiscalOptions() {
    this.managerService.getActivityFiscalOptions().subscribe((data: any) => {
      data.forEach((element: any) => {
        element.startDate=new Date(element.startDate).toISOString()
        element.endDate=new Date(element.endDate).toISOString()
      });
      this.fiscalOptionsList = data;
      this.fiscalYearList = Array.from(new Set(data.map((x: any) => x.fiscalYear)));
      this.fiscalQuarterList = Array.from(new Set(data.map((x: any) => x.fiscalQuarter)));
    }, (_err: any) => {
      //this.errors = err;
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  };

  getCountriesByRegion() {
    this.managerService.getCountryListByRegion(this.regionsList).subscribe((data: any) => {
      this.regionCountryMapping = data

      if(this.copyLeaderChallenge && this.copyLeaderChallenge.id){
        this.getCloneLeaderChallengeById(this.copyLeaderChallenge.id)
      }
      else if (this.editedLeaderChallenge && this.editedLeaderChallenge.id) {
        this.getLeaderchallengeDataById(this.editedLeaderChallenge.id)
      } else {
        this.showSpinner = false;
        this.createLeaderboardFormForNew()
      }
    }, (_err: any) => {
      //this.errors = err;
      this.popupMessageService.showError('Something went wrong', 'error');
    })
  }

  setCountryListByRegion() {
    let dropdownData: any[] = [];
    this.regionCountryMapping.forEach((regionData: any) => {
      this.createNewChallengeForm.value.assignRegion.forEach((region: any) => {
        if (region === regionData.region) {
          dropdownData = [...dropdownData, ...regionData]
        }
      })
    })
    this.countriesList = dropdownData
    let selectedCountries: any[] = []
    this.createNewChallengeForm.value.countryList.forEach((country: any) => {
      if (this.createNewChallengeForm.value.assignRegion.includes(dropdownData.filter((x: any) =>
        x.countryCode === country.countryCode)[0] && dropdownData.filter((x: any) =>
        x.countryCode === country.countryCode)[0].region
      )) {
        selectedCountries = [...selectedCountries, ...country]
      }
    })
    this.createNewChallengeForm.controls.countryList.setValue(selectedCountries)
    this.onRegionSelection();
  }

  onTargetTypeChange() {
    let targetType = this.createNewChallengeForm.controls.targetType.value
    if (targetType === 'SAME_FOR_ALL_PARTICIPANTS') {
      this.createNewChallengeForm.controls.participantGroup.value.forEach((group: any, index: number) => {
        this.createNewChallengeForm.controls.participantGroup.value[index].addTargetGroup.forEach((targetGroup: any, tarIndex: number) => {
          (this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('addTargetGroup').controls[tarIndex].get('setTargets').setValue(null)
          (this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('addTargetGroup').controls[tarIndex].get('setTargets').clearValidators()
          (this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('addTargetGroup').controls[tarIndex].get('setTargets').updateValueAndValidity()
          (this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('addTargetGroup').controls[tarIndex].get('minTargets').setValue("")
          (this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('addTargetGroup').controls[tarIndex].get('minTargets').setValidators([Validators.required])
          (this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('addTargetGroup').controls[tarIndex].get('minTargets').updateValueAndValidity()
        })
      })
    } else {
      this.createNewChallengeForm.controls.participantGroup.value.forEach((group: any, index: number) => {
        this.createNewChallengeForm.controls.participantGroup.value[index].addTargetGroup.forEach((targetGroup: any, tarIndex: number) => {
          (this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('addTargetGroup').controls[tarIndex].get('setTargets').setValue([])
          (this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('addTargetGroup').controls[tarIndex].get('setTargets').setValidators([], [Validators.required])
          (this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('addTargetGroup').controls[tarIndex].get('setTargets').updateValueAndValidity()
          (this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('addTargetGroup').controls[tarIndex].get('minTargets').setValue(null)
          (this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('addTargetGroup').controls[tarIndex].get('minTargets').clearValidators()
          (this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('addTargetGroup').controls[tarIndex].get('minTargets').updateValueAndValidity()
        })
      })
    }
  }

  onRewardTypeChange() {
    let rewardType = this.createNewChallengeForm.controls.rewardType.value
    this.createNewChallengeForm.controls.participantGroup.value.forEach((group: any, index: number) => {
      let noOfRewards = this.createNewChallengeForm.controls.participantGroup.value[index].rewardsRankingGroup.length;
      for (let i = noOfRewards - 1; i >= 0; i--) {
        const control = <FormArray>(this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('rewardsRankingGroup');
        control.controls[i].get('points')!.setValue('')
      }
    })
    this.onRegionSelection();
    // if (rewardType === 'MANUAL') {
      // this.createNewChallengeForm.get('rewards').setValue(null);
      // this.createNewChallengeForm.get('rewards').clearValidators();
      // this.createNewChallengeForm.get('rewards').updateValueAndValidity();
      // this.createNewChallengeForm.controls.participantGroup.value.forEach((group, index) => {
      //   let noOfRewards = this.createNewChallengeForm.controls.participantGroup.value[index].rewardsRankingGroup.length;
      //   for (let i = noOfRewards - 1; i >= 0; i--) {
      //     const control = <FormArray>this.createNewChallengeForm.get('participantGroup')['controls'][index].get('rewardsRankingGroup');
      //     control.removeAt(i);
      //   }
      // })
    // } else {
      // this.createNewChallengeForm.get('rewards').setValue('');
      // this.createNewChallengeForm.get('rewards').setValidators([Validators.required]);
      // this.createNewChallengeForm.get('rewards').updateValueAndValidity();

      // this.createNewChallengeForm.controls.participantGroup.value.forEach((group, index) => {
      //   const control = <FormArray>this.createNewChallengeForm.get('participantGroup')['controls'][index].get('rewardsRankingGroup');
      //   if (control.length === 0) {
      //     control.push(this.createRankingGroupArray());
      //   }
      // })
    // }
  }

  toggleAllSelection(){
    const assignRoleControl = this.createNewChallengeForm.get('assignRole');
    if (!assignRoleControl) { return; }
    if (this.createNewChallengeForm.get('selectallUsers')!.value) {
      assignRoleControl.setValue(this.roleList.map((role: any) => role.id));
    } else {
      assignRoleControl.setValue([]);
    }
  };

  optionClick() {
    const assignRoleControl = this.createNewChallengeForm.get('assignRole');
    const selectedCount = assignRoleControl ? (assignRoleControl.value || []).length : 0;
    this.createNewChallengeForm.patchValue({
      selectallUsers: selectedCount === this.roleList.length
    });
  };

  onPartnerCompaniesFileSelected(rows: any[]) {
    if (!rows || rows.length === 0) { return; }
    const columnsName = Object.keys(rows[0]);
    const list: string[] = rows.map((val: any) => val[columnsName[0]].toString());
    this.createNewChallengeForm.controls.partnerCompanies.setValue(list);
  }

  partnerCompaniesClear() {
    this.createNewChallengeForm.controls.partnerCompanies.setValue([]);
  }

  onParticipantIdsFileSelected(rows: any[], parentIndex: any) {
    if (!rows || rows.length === 0) { return; }
    const columnsName = Object.keys(rows[0]);
    const list: string[] = rows.map((val: any) => val[columnsName[0]].toString());
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex].controls.participantIds.setValue(list);
  }

  participantIdsClear(parentIndex: any) {
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex].controls.participantIds.setValue([]);
  }

  onProductSkusFileSelected(rows: any[], parentIndex: any, targetIndex: any) {
    if (!rows || rows.length === 0) { return; }
    const columnsName = Object.keys(rows[0]);
    const list: string[] = rows.map((val: any) => val[columnsName[0]].toString());
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex].controls.addTargetGroup.controls[targetIndex].controls.eligibleProductSkus.setValue(list);
  }

  productSkusClear(parentIndex: any, targetIndex: any) {
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex].controls.addTargetGroup.controls[targetIndex].controls.eligibleProductSkus.setValue([]);
  }

  onProductFamiliesFileSelected(rows: any[], parentIndex: any, targetIndex: any) {
    if (!rows || rows.length === 0) { return; }
    const columnsName = Object.keys(rows[0]);
    const list: string[] = rows.map((val: any) => val[columnsName[0]].toString());
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex].controls.addTargetGroup.controls[targetIndex].controls.eligibleProductFamilies.setValue(list);
  }

  productFamiliesClear(parentIndex: any, targetIndex: any) {
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex].controls.addTargetGroup.controls[targetIndex].controls.eligibleProductFamilies.setValue([]);
  }

  onSetTargetsFileSelected(rows: any[], parentIndex: any, targetIndex: any) {
    if (!rows || rows.length === 0) { return; }
    const columnsName = Object.keys(rows[0]);
    const list = rows.map((val: any) => ({
      participantId: val[columnsName[0]].toString(),
      target: val[columnsName[1]].toString()
    }));
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex].controls.addTargetGroup.controls[targetIndex].controls.setTargets.setValue(list);
  }

  setTargetsClear(parentIndex: any, targetIndex: any) {
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex].controls.addTargetGroup.controls[targetIndex].controls.setTargets.setValue([]);
  }

  showDownloadExcelFormatDialog(excelType: any): void {
    if (excelType === 'TARGETS') {
      if (this.createNewChallengeForm.value.participantType === 'INDIVIDUAL') {
        excelType = 'TARGETS_INDIVIDUAL';
      } else {
        excelType = 'TARGETS_COMPANY';
      }
    }
    if (excelType === 'PARTICIPANTIDS') {
      if (this.createNewChallengeForm.value.participantType === 'INDIVIDUAL') {
        excelType = 'PARTICIPANT_INDIVIDUAL';
      } else {
        excelType = 'PARTICIPANT_COMPANY';
      }
    }
    this.downloadExcelType = excelType;
    this.downloadExcelModalOpen = true;
  }

  closeDownloadExcelModal(): void {
    this.downloadExcelModalOpen = false;
  }

  downloadExcel(): void {
    let columnData = [];
    if (this.downloadExcelType === 'BEGEOID') {
      columnData = [['BEGEOID']];
    } else if (this.downloadExcelType === 'END_CUSTOMER_ID') {
      columnData = [['END CUSTOMER GLOBAL HQ ID']];
    } else if (this.downloadExcelType === 'INDIVIDUAL_PRODUCT_LIST') {
      columnData = [['PRODUCT', 'TYPE', 'PAYOUT']];
    } else if (this.downloadExcelType === 'PRODUCT_LIST') {
      columnData = [['PRODUCT']];
    } else if (this.downloadExcelType === 'EXCEL_MERGE') {
      columnData = [['PRODUCT', 'TYPE']];
    } else if (this.downloadExcelType === 'PRODUCT_SKUS') {
      columnData = [['PRODUCT SKUS']];
    } else if (this.downloadExcelType === 'PRODUCT_FAMILIES') {
      columnData = [['PRODUCT FAMILIES']];
    } else if (this.downloadExcelType === 'TARGETS_INDIVIDUAL') {
      columnData = [['USER', 'TARGET']];
    } else if (this.downloadExcelType === 'TARGETS_COMPANY') {
      columnData = [['BEGEOID', 'TARGET']];
    } else if (this.downloadExcelType === 'PARTICIPANT_INDIVIDUAL') {
      columnData = [['USERIDS']];
    } else if (this.downloadExcelType === 'PARTICIPANT_COMPANY') {
      columnData = [['BEGEOIDS']];
    } else if (this.downloadExcelType === 'UPLOAD_COMPLETION') {
      columnData = [['CCOID', 'Date of completion (MM/DD/YYYY)']];
    } else {
      return;
    }
    let workbook = XLSX.utils.book_new(),
      worksheet = XLSX.utils.aoa_to_sheet(columnData);
    workbook.SheetNames.push('First');
    workbook.Sheets['First'] = worksheet;
    let xlsbin = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
    let buffer = new ArrayBuffer(xlsbin.length),
      array = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    let xlsblob = new Blob([buffer], { type: 'application/octet-stream' });
    let url = window.URL.createObjectURL(xlsblob),
      anchor = document.createElement('a');
    anchor.href = url;
    if (this.downloadExcelType === 'BEGEOID') {
      anchor.download = 'BEGEOID_LIST.xlsx';
    } else if (this.downloadExcelType === 'END_CUSTOMER_ID') {
      anchor.download = 'END_CUSTOMER_LIST.xlsx';
    } else if (this.downloadExcelType === 'INDIVIDUAL_PRODUCT_LIST') {
      anchor.download = 'PRODUCT_PAYOUTS.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_LIST') {
      anchor.download = 'PRODUCT_LIST.xlsx';
    } else if (this.downloadExcelType === 'EXCEL_MERGE') {
      anchor.download = 'PRODUCT_LIST_ANY_PRODUCT.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_SKUS') {
      anchor.download = 'PRODUCT_SKUS.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_FAMILIES') {
      anchor.download = 'PRODUCT_FAMILIES.xlsx';
    } else if (this.downloadExcelType === 'TARGETS_INDIVIDUAL') {
      anchor.download = 'TARGETS_INDIVIDUAL.xlsx';
    } else if (this.downloadExcelType === 'TARGETS_COMPANY') {
      anchor.download = 'TARGETS_COMPANY.xlsx';
    } else if (this.downloadExcelType === 'PARTICIPANT_INDIVIDUAL') {
      anchor.download = 'PARTICIPANT_INDIVIDUAL.xlsx';
    } else if (this.downloadExcelType === 'PARTICIPANT_COMPANY') {
      anchor.download = 'PARTICIPANT_COMPANY.xlsx';
    } else if (this.downloadExcelType === 'UPLOAD_COMPLETION') {
      anchor.download = 'Participation Challenge Completions Upload.xlsx';
    }
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  openProductDialogContent(dialogType: string, index?: number, groupIndex?: number) {
    if (dialogType === 'PARTICIPANTIDS') {
      dialogType = this.createNewChallengeForm.value.participantType === 'INDIVIDUAL'
        ? 'PARTICIPANT_INDIVIDUAL'
        : 'PARTICIPANT_COMPANY';
    }
    this.uploadListDialogType = dialogType;
    if (dialogType === 'BEGEOID') {
      this.uploadListDialogData = this.createNewChallengeForm.controls.partnerCompanies.value;
    } else if (dialogType === 'PRODUCT_SKUS') {
      this.uploadListDialogData = (this.createNewChallengeForm.controls.participantGroup as any)['controls'][index!].controls.addTargetGroup.controls[groupIndex!].controls.eligibleProductSkus.value;
    } else if (dialogType === 'PRODUCT_FAMILIES') {
      this.uploadListDialogData = (this.createNewChallengeForm.controls.participantGroup as any)['controls'][index!].controls.addTargetGroup.controls[groupIndex!].controls.eligibleProductFamilies.value;
    } else if (dialogType === 'SET_TARGETS') {
      this.uploadListDialogData = (this.createNewChallengeForm.controls.participantGroup as any)['controls'][index!].controls.addTargetGroup.controls[groupIndex!].controls.setTargets.value;
    } else if (dialogType === 'PARTICIPANT_INDIVIDUAL' || dialogType === 'PARTICIPANT_COMPANY') {
      this.uploadListDialogData = (this.createNewChallengeForm.controls.participantGroup as any)['controls'][index!].controls.participantIds.value;
    }
    this.uploadListModalOpen = true;
  }

  get uploadListModalTitle(): string {
    if (this.uploadListDialogType === 'PRODUCT_SKUS') { return 'Eligible Product SKUs'; }
    if (this.uploadListDialogType === 'PRODUCT_FAMILIES') { return 'Eligible Product Families'; }
    if (this.uploadListDialogType === 'BEGEOID' || this.uploadListDialogType === 'PARTICIPANT_COMPANY') { return 'Eligible BegeoId List'; }
    if (this.uploadListDialogType === 'SET_TARGETS') { return 'Eligible Targets List'; }
    if (this.uploadListDialogType === 'PARTICIPANT_INDIVIDUAL') { return 'Eligible Users Ids'; }
    return '';
  }

  get uploadListColumns(): DataTableColumn[] {
    if (this.uploadListDialogType === 'SET_TARGETS') {
      return [
        { field: 'participantId', header: 'Participant Id' },
        { field: 'target', header: 'Target' }
      ];
    }
    let header = '';
    if (this.uploadListDialogType === 'PRODUCT_SKUS') { header = 'Product SKUs'; }
    else if (this.uploadListDialogType === 'PRODUCT_FAMILIES') { header = 'Product Families'; }
    else if (this.uploadListDialogType === 'BEGEOID' || this.uploadListDialogType === 'PARTICIPANT_COMPANY') { header = 'BeGeoId'; }
    else if (this.uploadListDialogType === 'PARTICIPANT_INDIVIDUAL') { header = 'User Ids'; }
    return [{ field: 'value', header }];
  }

  get uploadListRows(): any[] {
    const start = (this.uploadListPage - 1) * this.uploadListPageSize;
    const slice = this.uploadListDialogData.slice(start, start + this.uploadListPageSize);
    if (this.uploadListDialogType === 'SET_TARGETS') { return slice; }
    return slice.map((item: any) => ({ value: item }));
  }

  onUploadListPageChange(page: number): void {
    this.uploadListPage = page;
  }

  closeUploadListModal(): void {
    this.uploadListModalOpen = false;
    this.uploadListDialogType = '';
    this.uploadListDialogData = [];
    this.uploadListPage = 1;
  }

  getAllRoles() {
    this.profileService.getAllRoles().subscribe((data: any) => {
      if (data) {
        this.roleList = data;
      }
    })
  };

  onPreRequisitesChange(event: any) {
    if (event) {
      const startDate = this.createNewChallengeForm.value.startDate;
      const endDate = this.createNewChallengeForm.value.endDate;
      const regions = this.createNewChallengeForm.value.assignRegion;
      const participantType = this.createNewChallengeForm.value.participantType;
      if (!startDate || !endDate || !regions || regions.length === 0 || !participantType) {
        this.preReqFlag = 'Note: To mention any prerequisites make sure you provide start date, end date, regions and participant type';
      } else {
        this.preReqFlag = '';
      }
      this.createNewChallengeForm.addControl('preRequisitesGroup', this.fb.array([this.createPreRequisitesArray()]))
    } else {
      this.preReqFlag = '';
      this.createNewChallengeForm.removeControl('preRequisitesGroup');
      this.createNewChallengeForm.patchValue({
        minPrerequisitesToBeMet: ''
      })
    }
  }

  removeParticipantBlock(index: any) {
    if (this.editedChallengeData.productsBookingLdbChPgList[index] && this.editedChallengeData.productsBookingLdbChPgList[index].id) {
      (this.createNewChallengeForm.controls.participantGroup as any)['controls'][index].controls.deleted.setValue(true);
    } else {
      const control = <FormArray>this.createNewChallengeForm.get('participantGroup');
      control.removeAt(index)
    }
  }

  resetChallenge() {
    if (this.editedLeaderChallenge || this.copyLeaderChallenge) {
      this.updateFormWithChallengeData();
    } else {
      this.createLeaderboardFormForNew();
    }
  }

  submitChallenge() {
    const payload: any = this.createSubmissionPayload()
    payload['creatorType'] = 'CISCO_ADMIN';
    this.managerService.createNewLeaderboardChallenge(payload).subscribe((_data: any) => {
      this.popupMessageService.showSuccess('Leaderboard challenge created successfully', 'success');
      this.showLeaderboardChallenges.emit()
    }, (_err: any) => {
      //this.errors = err;
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  updateChallenge() {
    const payload: any = this.createSubmissionPayload()
    payload['id'] = this.editedChallengeData.id;
    payload['status'] = this.editedChallengeData.status;
    payload['creatorType'] = this.editedChallengeData.creatorType;
    this.managerService.createNewLeaderboardChallenge(payload).subscribe((_data: any) => {
      this.popupMessageService.showSuccess('Leaderboard challenge created successfully', 'success');
      this.showLeaderboardChallenges.emit()
    }, (_err: any) => {
      //this.errors = err;
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  createSubmissionPayload() {
    return {
      name: this.createNewChallengeForm.value.activityName,
      fiscalYear: this.createNewChallengeForm.value.fiscalYear,
      fiscalQuarters: this.createNewChallengeForm.value.fiscalQuarter,
      startDate: this.createNewChallengeForm.value.startDate,
      endDate: this.createNewChallengeForm.value.endDate,
      cutoffDate: this.createNewChallengeForm.value.cutOffDate,
      acronym: this.createNewChallengeForm.value.acronym,
      type: "PRODUCTS_BOOKING",
      challengeIdentifier: null,
      category: "SPECIAL",
      description: this.createNewChallengeForm.value.description.replace(/&#160;/g, ""),
      challengeRewards: this.createNewChallengeForm.value.challengeRewards.replace(/&#160;/g, ""),
      participantType: this.createNewChallengeForm.value.participantType,
      rewardType: this.createNewChallengeForm.value.rewardType,
      targetType: this.createNewChallengeForm.value.targetType,
      visibilities: this.createNewChallengeForm.value.visibility,
      regions: this.createNewChallengeForm.value.assignRegion,
      countries: this.createNewChallengeForm.value.countryList.map((x: any) => x.countryCode),
      roleIds: this.createNewChallengeForm.value.participantType === 'INDIVIDUAL' ? this.createNewChallengeForm.value.assignRole : [],
      beGeoIds: this.createNewChallengeForm.value.partnerCompanies,
      minimumNumberOfPrerequisitesToBeMet: this.createNewChallengeForm.value.minPrerequisitesToBeMet || null,
      requiredPrerequisites:this.createNewChallengeForm.value.preRequisites,
      prerequisitesDTO: this.createNewChallengeForm.value.preRequisites ? this.getPrerequisitesData() : [],
      shouldClaim: this.createNewChallengeForm.value.shouldClaim,
      productsBookingLdbChPgList: this.getProductsBookingData(),
      creatorId: this.userProfile.id,
      credits: this.createNewChallengeForm.value.rewardType === 'CREDITS' ? Number(this.createNewChallengeForm.value.rewards) : null,
      points: this.createNewChallengeForm.value.rewardType === 'POINTS' ? Number(this.createNewChallengeForm.value.rewards) : null,
      budgetSource: this.createNewChallengeForm.value.budgetSource,
      budgetCaps: this.getBudgetCapsData(this.createNewChallengeForm.value),
      visibilityEndDate:this.createNewChallengeForm.value.visibilityEndDate
    }
  }

  getProductsBookingData() {
    const productsBookingData = this.createNewChallengeForm.value.participantGroup.map((group: any, index: number) => {
      return {
        id: group.id,
        name: group.paticipantGroupName,
        minimumNumberOfTargetsToBeAchieved: Number(group.minNoOfTargets),
        participantBeGeoIds: this.createNewChallengeForm.value.participantType === 'COMPANY' ? group.participantIds : [],
        participantUserIds: this.createNewChallengeForm.value.participantType === 'INDIVIDUAL' ? group.participantIds : [],
        sortOrder:index + 1,
        deleted: group.deleted,
        winnersCount: group.rewardsRankingGroup.filter((x: any) => x.position && x.points).length,
        winnersReward: group.rewardsRankingGroup.filter((x: any) => x.position && x.points).map((x: any, i: number) => {
          return {
              leaderBoardPosition: i+1,
              points: this.createNewChallengeForm.value.rewardType === 'POINTS' ? Number(x.points) : 0,
              credits: this.createNewChallengeForm.value.rewardType === 'CREDITS' ? Number(x.points) : 0,
              manualDescription: this.createNewChallengeForm.value.rewardType === 'MANUAL' ? x.points : ""
          }
        }),
        productsBookingLdbChTargetList: group.addTargetGroup.map((target: any, tarIndex: number) => {
          return {
            id: target.id,
            name: target.targetGroupName,
            productSkus: target.eligibleProductSkusNotApplicable ? [] : target.eligibleProductSkus,
            productFamilies: target.eligibleProductFamiliesNotApplicable ? [] : target.eligibleProductFamilies,
            targetBooking: this.createNewChallengeForm.value.targetType === 'SAME_FOR_ALL_PARTICIPANTS' ? target.minTargets : "",
            participantTargets: this.createNewChallengeForm.value.targetType === 'PER_PARTICIPANT' ? target.setTargets.map((tar: any) => {
              return {
                beGeoId: this.createNewChallengeForm.value.participantType === 'COMPANY' ? tar.participantId : 0,
                userId: this.createNewChallengeForm.value.participantType === 'INDIVIDUAL' ? tar.participantId : 0,
                targetBooking: tar.target
              }
            }) : [],
            optional: target.isOptional,
            sortOrder: tarIndex + 1,
            deleted: target.deleted,
          }
        })
      }
    })
    return productsBookingData;
  }

  getPrerequisitesData() {
    let preRequisites: any[] = []
    this.createNewChallengeForm.value.preRequisitesGroup.forEach((x: any) => {
      if (x.challengeType === 'Activity Challenge') {
        preRequisites.push({
            preqActivityChallengeId: x.activityChallenge,
            optional: x.isOptional
        })
      }
      if (x.challengeType === 'Leaderboard Challenge') {
        preRequisites.push({
            preqLeaderboardChallengeId: x.activityChallenge,
            optional: x.isOptional
        })
      }
    })
    return preRequisites
  }

  getLeaderchallengeDataById(id: any) {
    this.managerService.getLeaderboardChallengeById(id).subscribe((data: any) => {
      this.editedChallengeData = data;
      this.updateFormWithChallengeData();
    }, (_err: any) => {
      //this.errors = err;
      this.popupMessageService.showError('Something went wrong', 'error');
      this.showSpinner = false;
    });
  }

  getCloneLeaderChallengeById(id: any) {
    this.managerService.cloneLeaderChallengeById(id).subscribe((data: any)=>{
      this.editedChallengeData = data;
      this.updateFormWithChallengeData();
    },(_err: any)=>{
      this.popupMessageService.showError('Something went wrong', 'error');
      this.showSpinner = false;
    })
  }

  updateFormWithChallengeData() {
    this.createNewChallengeForm = this.fb.group({
      activityName: [this.editedChallengeData.name, Validators.required],
      fiscalYear: [this.editedChallengeData.fiscalYear, Validators.required],
      fiscalQuarter: [this.editedChallengeData.fiscalQuarters, Validators.required],
      startDate: [new Date(this.editedChallengeData.startDate), Validators.required],
      endDate: [new Date(this.editedChallengeData.endDate), Validators.required],
      cutOffDate:this.editedChallengeData.cutoffDate? [new Date(this.editedChallengeData.cutoffDate), Validators.required]:'',
      assignRegion: [this.editedChallengeData.regions, Validators.required],
      assignRole: this.editedChallengeData.participantType === 'INDIVIDUAL' ?[this.editedChallengeData.roleIds, Validators.required]:[null],
      partnerCompanies: [this.editedChallengeData.beGeoIds],
      acronym:[this.editedChallengeData.acronym,Validators.required],
      description: [this.editedChallengeData.description, Validators.required],
      challengeRewards: [this.editedChallengeData.challengeRewards, [Validators.required]],
      selectallUsers:[this.roleList.length === this.editedChallengeData.roleIds.length],
     // rewards: this.editedChallengeData.rewardType === 'MANUAL' ? [null] : [(this.editedChallengeData.credits || this.editedChallengeData.points), [Validators.required]],
      participantGroup: this.fb.array(this.updateParticipantArray(this.editedChallengeData.productsBookingLdbChPgList)),
      participantType: [this.editedChallengeData.participantType, Validators.required],
      countryList: [this.getCountryList()],
      rewardType: [this.editedChallengeData.rewardType, Validators.required],
      targetType: [this.editedChallengeData.targetType, Validators.required],
      visibility: [this.editedChallengeData.visibilities, Validators.required],
      preRequisites: this.editedChallengeData.requiredPrerequisites,
      shouldClaim: [this.editedChallengeData.shouldClaim],
      minPrerequisitesToBeMet: [this.editedChallengeData.minimumNumberOfPrerequisitesToBeMet],
      budgetCapByRegionGroup: this.fb.array(this.setBudgetCapData(this.editedChallengeData)),
      budgetSource: this.editedChallengeData.budgetSource,
      visibilityEndDate:this.editedChallengeData.visibilityEndDate ? new Date(this.editedChallengeData.visibilityEndDate) : null
    });
    if(this.editedChallengeData.requiredPrerequisites && this.editedChallengeData.prerequisitesDTO.length){
      this.preReqData=this.editedChallengeData.prerequisitesDTO;
       this.createNewChallengeForm.addControl('preRequisitesGroup', this.fb.array(this.updatePreRequisites(this.editedChallengeData.prerequisitesDTO)))
      this.setChallengeDropdownData(this.editedChallengeData.prerequisitesDTO)
    }
    
    this.showSpinner = false;
  }

  updateParticipantArray(participantArray: any) {
    let participantArrayGroup: any[] = []
    participantArray.forEach((participant: any) => {
      participantArrayGroup.push(this.fb.group({
        id: [participant.id],
        paticipantGroupName: [participant.name, [Validators.required]],
        participantIds: [participant.participantBeGeoIds.length > 0 ? participant.participantBeGeoIds : participant.participantUserIds, Validators.required],
        minNoOfTargets: [participant.minimumNumberOfTargetsToBeAchieved, [Validators.required]],
        addTargetGroup: this.fb.array(this.updateTargetGroupArray(participant.productsBookingLdbChTargetList)),
        rewardsRankingGroup: this.fb.array(this.updateRankingGroupArray(participant.winnersReward)),
        deleted: [false]
      }));
    })
    return participantArrayGroup
  }

  updateTargetGroupArray(targetGroupList: any) {
    let updatedTargetList: any[] = []
    let targetType = this.editedChallengeData.targetType
    targetGroupList.forEach((target: any) => {
      if (targetType === 'SAME_FOR_ALL_PARTICIPANTS') {
        updatedTargetList.push(this.fb.group({
          id: [target.id],
          targetGroupName: [target.name, [Validators.required]],
          eligibleProductSkus: [target.productSkus],
          eligibleProductSkusNotApplicable: [target.productSkus.length === 0],
          eligibleProductFamilies: [target.productFamilies],
          eligibleProductFamiliesNotApplicable: [target.productFamilies.length === 0],
          setTargets: [null],
          minTargets: [target.targetBooking, [Validators.required]],
          isOptional: [target.optional],
          deleted: [false]
        }, { validator: this.skuOrFamilyDataRequired}))
      } else {
        updatedTargetList.push(this.fb.group({
          id: [target.id],
          targetGroupName: [target.name, [Validators.required]],
          eligibleProductSkus: [target.productSkus],
          eligibleProductSkusNotApplicable: [target.productSkus.length === 0],
          eligibleProductFamilies: [target.productFamilies],
          eligibleProductFamiliesNotApplicable: [target.productFamilies.length === 0],
          setTargets:[this.setTargetData(target.participantTargets), [Validators.required]],
          minTargets: [null],
          isOptional: [target.optional],
          deleted: [false]
        }, { validator: this.skuOrFamilyDataRequired}))
      }
    })
    return updatedTargetList
  }

  updateRankingGroupArray(winnersReward: any) {
    let updatedRankingGroup: any[] = []
    winnersReward.forEach((winner: any) => {
      updatedRankingGroup.push(this.fb.group({
        position: [winner.leaderBoardPosition, Validators.required],
        points: [(winner.credits || winner.points || winner.manualDescription), Validators.required]
      }));
    })
    return updatedRankingGroup;
  }

  getCountryList() {
    let dropdownData: any[] = []
    let selectedCountries: any[] = []
    this.regionCountryMapping.forEach((regionData: any) => {
      this.editedChallengeData.regions.forEach((region: any) => {
        if (region === regionData.region) {
          dropdownData = [...dropdownData, ...regionData]
        }
      })
    })
    this.countriesList = dropdownData;
    selectedCountries = this.countriesList.filter((country: any) => this.editedChallengeData.countries.includes(country.countryCode));
    return selectedCountries;
  }

  onChallengeTypeChange(ele: any, index: any) {
    this.activityDropdownList[index]=[];
    this.selectedChallengeType = (this.createNewChallengeForm.controls.preRequisitesGroup as any)['controls'][index].value.challengeType;
    const rawStart = this.createNewChallengeForm.value.startDate;
    const rawEnd = this.createNewChallengeForm.value.endDate;
    const sd = rawStart ? new Date(rawStart) : null;
    const ed = rawEnd ? new Date(rawEnd) : null;
    let startDate: any = sd ? `${sd.getFullYear()}-${String(sd.getMonth() + 1).padStart(2, '0')}-${String(sd.getDate()).padStart(2, '0')}` : null;
    let endDate: any = ed ? `${ed.getFullYear()}-${String(ed.getMonth() + 1).padStart(2, '0')}-${String(ed.getDate()).padStart(2, '0')}` : null;
    let regions = this.createNewChallengeForm.value.assignRegion;
    if (this.selectedChallengeType && startDate && endDate && regions.length>0) {
      this.preReqFlag='';
      if (this.selectedChallengeType === 'Activity Challenge') {
        this.managerService.getActivityData(startDate, endDate, regions,this.createNewChallengeForm.value.participantType).subscribe((data: any)=>{
          this.activityDropdownList[index] = data.ACTIVITY_CHALLENGES;
          if(this.editedChallengeData){
          let checkDropdownValueExist=this.activityDropdownList[index].some((item: any)=>item.id === this.preReqData[index].preqActivityChallengeId)
          if(!checkDropdownValueExist){
            this.preReqData[index].id=this.preReqData[index].preqActivityChallengeId;
            this.activityDropdownList[index].push(this.preReqData[index])
          }
        }
        }, (_err: any) => {
          this.popupMessageService.showError('Something went wrong', 'error');
        })
      }
      if (this.selectedChallengeType === 'Leaderboard Challenge') {
        this.managerService.getActiveLeaderboardChallenges(startDate, endDate, regions,this.createNewChallengeForm.value.participantType).subscribe((data: any)=>{
         if(data){
          this.activityDropdownList[index] = data;
          if(this.editedChallengeData){
            this.activityDropdownList[index]=  data.filter((x: any)=>{ return x.id!=this.editedChallengeData.id})
            let checkDropdownValueExist=this.activityDropdownList[index].some((item: any)=>item.id === this.preReqData[index].preqLeaderboardChallengeId)
            if(!checkDropdownValueExist){
              this.preReqData[index].id=this.preReqData[index].preqLeaderboardChallengeId;
              this.activityDropdownList[index].push(this.preReqData[index])
            }
    
            
           }
         }
    
        })
      }
    } else {
      this.activityDropdownList[index] = [];
    }
  };

  get budgetCapByRegionGroupArray(): FormArray {
    return <FormArray>this.createNewChallengeForm.get('budgetCapByRegionGroup');
  };
  onRegionSelection() {
    if (this.createNewChallengeForm.controls.rewardType.value === 'POINTS') {
      const assignRegionControl = this.createNewChallengeForm.get('assignRegion');
      const selectedRegions: any[] = assignRegionControl ? assignRegionControl.value || [] : [];
      this.regionsList.forEach((region: any) => {
        const index = this.budgetCapByRegionGroupArray.value.findIndex((budget: any) => budget.region === region);
        const isSelected = selectedRegions.indexOf(region) > -1;
        if (isSelected && index === -1) {
          this.budgetCapByRegionGroupArray.push(this.addBudgetCapPerRegionGroup(region));
        }
        if (!isSelected && index > -1) {
          this.budgetCapByRegionGroupArray.removeAt(index);
        }
      });
      this.createNewChallengeForm.get('budgetSource')!.setValidators([Validators.required]);
      this.createNewChallengeForm.get('budgetSource')!.updateValueAndValidity();
    } else {
      this.createNewChallengeForm.get('budgetSource')!.setValue(null);
      this.createNewChallengeForm.get('budgetSource')!.clearValidators();
      this.createNewChallengeForm.get('budgetSource')!.updateValueAndValidity();
      while (this.budgetCapByRegionGroupArray.value.length) {
        this.budgetCapByRegionGroupArray.removeAt(0);
      }
    }
  };
  addBudgetCapPerRegionGroup(region: any) {
    return this.fb.group({
      region: [region],
      budgetCap: ['', [Validators.required, Validators.pattern(CONSTANTS.regex.notZero)]],
      createdBy: [''],
      id: [''],
      modifiedBy: ['']
    })
  };
   setBudgetCapData(res: any) {
    let budgetData: any[] = []
    if (res.rewardType === 'POINTS') {
      res.budgetCaps.forEach((budget: any) => {
        budgetData.push(this.updateBudgetCapPerRegionGroup(budget));
      })
    }
    return budgetData
  };
  updateBudgetCapPerRegionGroup(budget: any) {
    return this.fb.group({
      region: [budget.region],
      budgetCap: [budget.amount, [Validators.required, Validators.pattern(CONSTANTS.regex.notZero)]],
      createdBy: [budget.createdBy],
      id: [budget.id],
      modifiedBy: ['']
    })
  };
  getBudgetCapsData(formData: any) {
    let budgetCapData: any[] = [];
    if (formData.rewardType === 'POINTS') {
      budgetCapData = formData.budgetCapByRegionGroup.map((budgetRegion: any) => {
        return {
          activityBudgetCapType: "BUDGETCAP_REGIONAL",
          amount: budgetRegion.budgetCap,
          region: budgetRegion.region,
          id: budgetRegion.id || '',
          createdBy: budgetRegion.createdBy || this.userProfile.id,
          modifiedBy: this.editedLeaderChallenge ? this.userProfile.id : ''
        }
      })
    }
    return budgetCapData;
  };
  setTargetData(targetData: any) {
    return targetData.map((x: any) => {
      return {
          participantId: Number(x.beGeoId) || Number(x.userId),
          target: x.targetBooking
      }
    })
  };
  onParticipantTypeChange() {
    let participantType = this.createNewChallengeForm.controls.participantType.value;
    if (participantType === 'INDIVIDUAL') {
      this.createNewChallengeForm.get('assignRole')!.setValue([]);
      this.createNewChallengeForm.get('assignRole')!.setValidators([Validators.required]);
      this.createNewChallengeForm.get('assignRole')!.updateValueAndValidity();
    } else {
      this.createNewChallengeForm.get('assignRole')!.setValue(null);
      this.createNewChallengeForm.get('assignRole')!.clearValidators();
      this.createNewChallengeForm.get('assignRole')!.updateValueAndValidity();
    };
  };

  updatePreRequisites(data: any) {
     let updatedPrerequisites: any[] = []
    data.forEach((ele: any) => {
      updatedPrerequisites.push(this.fb.group({
        challengeType: [ele.preqLeaderboardChallengeId?'Leaderboard Challenge':'Activity Challenge', Validators.required],
        activityChallenge: [ele.preqLeaderboardChallengeId?ele.preqLeaderboardChallengeId:ele.preqActivityChallengeId, Validators.required],
        isOptional: [ele.optional, Validators.required]
      }));
    })
    return updatedPrerequisites;
  }
  setChallengeDropdownData(data: any) {
    data.forEach((ele: any, index: number) => {
      this.onChallengeTypeChange(ele,index)
      
    })
  
   
  }
 
  onActivityTypeChange(event: any, index: any) {
    let checkDuplicateObj: any[] = [];
    checkDuplicateObj=this.createNewChallengeForm.value.preRequisitesGroup.filter((x: any, grpIndex: number)=>((x.activityChallenge==event.target.value)&& (this.selectedChallengeType===x.challengeType) && grpIndex!=index ))

   if(checkDuplicateObj.length>0){
     this.prereqActivityChallengeFlag=true;
     (this.createNewChallengeForm.controls.preRequisitesGroup as any)['controls'][index].controls['activityChallenge'].setValue('');
   }else{
    this.prereqActivityChallengeFlag=false;
   }
  
 
  }
  OnchangeMinPrerequisite(){

   if(this.createNewChallengeForm.value.minPrerequisitesToBeMet > this.createNewChallengeForm.value.preRequisitesGroup.length){

    this.createNewChallengeForm.patchValue({
      minPrerequisitesToBeMet: ''
    })
    this.minPreRequisiteFlag=true
   }else{
    this.minPreRequisiteFlag=false;
   } 
  }
  cloneParticipantBlock(index: any) {
    const control = <FormArray>this.createNewChallengeForm.get('participantGroup');
    control.push(this.duplicateParticipantData(index));
  };
  duplicateParticipantData(index: any) {
    let participationFormGroup;
    participationFormGroup = this.fb.group({
      id: [null],
      paticipantGroupName: [this.createNewChallengeForm.value.participantGroup[index].paticipantGroupName, [Validators.required]],
      minNoOfTargets: [this.createNewChallengeForm.value.participantGroup[index].minNoOfTargets, [Validators.required]],
      participantIds: [this.createNewChallengeForm.value.participantGroup[index].participantIds, Validators.required],
      rewardsRankingGroup: this.fb.array(this.duplicateRankingGroupArray(index)),
      addTargetGroup: this.fb.array(this.duplicateTargetGroupArray(index)),
      deleted: [false]
    });
    return participationFormGroup
  };

  
  duplicateRankingGroupArray(index: any) {
    let rankingGroupArray: any[] = [];
    this.createNewChallengeForm.value.participantGroup[index].rewardsRankingGroup.forEach((winner: any) => {
      rankingGroupArray.push(this.fb.group({
        position:[winner.position,Validators.required],
        points:[(winner.credits || winner.points || winner.manualDescription), Validators.required]
      }))
    })
    return rankingGroupArray
  }
  duplicateTargetGroupArray(index: any) {
    let targetGroupArray: any[] = []
    let targetType = this.createNewChallengeForm ? this.createNewChallengeForm.controls.targetType.value : 'SAME_FOR_ALL_PARTICIPANTS';
    this.createNewChallengeForm.value.participantGroup[index].addTargetGroup.forEach((targetData: any) => {
      if (targetType === 'SAME_FOR_ALL_PARTICIPANTS') {
        targetGroupArray.push(this.fb.group({
          id: [null],
          targetGroupName: [targetData.targetGroupName, [Validators.required]],
          eligibleProductSkus: [targetData.eligibleProductSkus],
          eligibleProductSkusNotApplicable: [targetData.eligibleProductSkusNotApplicable],
          eligibleProductFamilies: [targetData.eligibleProductFamilies],
          eligibleProductFamiliesNotApplicable: [targetData.eligibleProductFamiliesNotApplicable],
          setTargets: [null],
          minTargets: [targetData.minTargets, [Validators.required]],
          isOptional: [targetData.isOptional],
          deleted: [false]
        }, { validator: this.skuOrFamilyDataRequired}));
      } else {
        targetGroupArray.push(this.fb.group({
          id: [null],
          targetGroupName: [targetData.targetGroupName, [Validators.required]],
          eligibleProductSkus: [targetData.eligibleProductSkus],
          eligibleProductSkusNotApplicable: [targetData.eligibleProductSkusNotApplicable],
          eligibleProductFamilies: [targetData.eligibleProductFamilies],
          eligibleProductFamiliesNotApplicable: [targetData.eligibleProductFamiliesNotApplicable],
          setTargets: [targetData.setTargets, [Validators.required]],
          minTargets: [null],
          isOptional: [targetData.isOptional],
          deleted: [false]
        }, { validator: this.skuOrFamilyDataRequired}));
      }
    });
    return targetGroupArray;
  };

  checkInactiveStatus(){
    const q = new Date();
    const m = q.getMonth();
    const d = q.getDate();
    const y = q.getFullYear();

    const todayDate = new Date(y,m,d);

    const mydate=new Date(this.editedLeaderChallenge.endDate);


    if((todayDate>mydate)&&this.editedLeaderChallenge.status==='INACTIVE')
    {
      this.readonlyFlag=true;
    }else{
      this.readonlyFlag=false;
    }
 
  }

  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: '150px',
      minHeight: '0',
      maxHeight: 'auto',
      width: '350px',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter text here...',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
    sanitize: true,
    toolbarPosition: 'top',

};
rewardEditorConfig: AngularEditorConfig = {
  editable: true,
    spellcheck: true,
    height: '97px',
    minHeight: '0',
    maxHeight: 'auto',
    width: '354px',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
  sanitize: true,
  toolbarPosition: 'top',

};

}

